<template>
  <!-- 通用组件 -->
  <!-- 
    0产品来源，1资金来源，2规格单位，3文档类型，4证件类型，5合同类型，6报告来源，7使用场所，
    8事件后果，9操作人员，10报告状态，11报告人类型，12盘点范围，13盘点方式,14财务分类,15品牌 
  -->
  <Index :type="15"></Index>
</template>

<script>

import Index from '@/views/components/normalCategoryTable'
export default {
  components: {
    Index
  }
};
</script>

<style lang="scss" scoped>
</style>